module.exports = __webpack_public_path__ + "media/images/client/favicons/site-tile-150x150-8f9c63344da6328aecfe07a7b5b6fca2.png";